import { Component, OnInit } from '@angular/core';
import { DependentMeepServerModel } from '../../models/dependent.model';
import { InputSelectModel } from '../input-select/inputSelect.model';
import { RechargeModel } from '../../models/recharge.model';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { DependentService } from '../../services/dependent.service';
import { ResponsibleService } from '../../services/responsible.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { RechargeService } from '../../services/recharge.service';
import { MaskHelper } from '../../helpers/mask';
import { BankSlipModel } from '../../models/bankslip.model';
import { Form } from '../../services/form';
import { PedidosModel } from '../defaulters/defaulters.model';

@Component({
  selector: 'app-debit-defaulters',
  templateUrl: './debit-defaulters.component.html',
  styleUrls: ['./debit-defaulters.component.less']
})
export class DebitDefaultersComponent extends Form implements OnInit {

  paymentMethods: InputSelectModel[] = new Array<InputSelectModel>();
  rechargeModel: RechargeModel = new RechargeModel();
  paymentMethod: any;
  routeParams: Params;
  creditCard = true;
  hasPaymentMethods = true;

  constructor(private router: Router, private route: ActivatedRoute, private dependentService: DependentService,
    private responsibleService: ResponsibleService, private notificationService: NotificationService) {
    super();
    this.rechargeModel.amountInputModel.setReadOnly();
    this.route.params.subscribe((params: Params) => {
      this.routeParams = params;
    });
  }

  ngOnInit() {
    this.dependentService.buscarPedidosEmAberto()
      .then((_pedidos: PedidosModel[]) => {
        this.rechargeModel.amount = _pedidos.find(pedido => pedido.Id === this.routeParams['id']).Valor;
        this.rechargeModel.amountToShow = this.rechargeModel.amount.toFixed(2);
        this.getPaymentMethods();
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  IsAnyPaymentMethod(): boolean {
    return this.paymentMethods.length > 0;
  }

  private getPaymentMethods() {
    this.responsibleService.getCreditCards()
      .then((_responsible) => {
        if (_responsible.length === 0) {
          this.hasPaymentMethods = false;
        }
        _responsible.forEach((creditCard) => {
          this.paymentMethods.push({title: `**** **** **** ${creditCard.finalNumero}`, value: creditCard});
        });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  goToCard() {
    this.router.navigate([`general/cartoes/`]);
  }

  creditCardRecharge() {
    this.dependentService.debitFromCreditCard(
      this.paymentMethod.id,
      this.rechargeModel.cvv,
      this.routeParams['idCartao'],
      this.routeParams['id'])
      .then(() => {
        this.notificationService.showSuccessNotification('Pagamento realizado com sucesso!')
          .then(() => {
            this.router.navigate([`general/home`]);
          });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  pagar() {
    if (this.getFormStatus()) {
      this.creditCardRecharge();
    } else {
      this.notificationService.showErrorNotification('Preencha o todos os campos!');
    }
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/debit-defaulters/debit-defaulters.component.ts